import React, { useEffect, useState } from "react";
import axios from "axios";
import { Grid, Card, CardMedia, CardContent, Typography } from "@mui/material";
import { getRetailerLogoForProduct } from "./shared/utils";

// Define styles directly as objects to avoid theme spacing issues
const styles = {
  root: {
    flexGrow: 1,
    padding: '16px',
  },
  card: {
    width: 345, // Fixed width
    height: 400, // Fixed height
    margin: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  media: {
    height: 200, // Fixed height for media
  },
  content: {
    flexGrow: 1,
  },
  link: {
    textDecoration: 'none',
    color: '#3F51B5', // Hardcoded primary color to match theme
  },
  gridContainer: {
    padding: '8px',
  },
};

const PriceDroppedTilesComponent = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_PRODUCTFETCHER_URL}/api/v1/products/pricedropped`)
      .then((response) => {
        setProducts(response.data);
      })
      .catch((error) => {
        console.error("Error fetching price dropped products:", error);
      });
  }, []);

  return (
    <div style={styles.root}>
      <Grid container spacing={3} style={styles.gridContainer}>
        {products.map((product) => (
          <Grid item xs={12} sm={6} md={4} key={product.catalogueId}>
            <Card style={styles.card}>
              <CardMedia
                style={{...styles.media, objectFit: 'contain'}}
                image={product.prodImg}
                title={product.prodDescription}
              />
              <CardContent style={styles.content}>
                <Typography gutterBottom variant="h6" component="h2">
                  {product.prodDescription}
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Price: ${product.price}
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  <a href={product.prodUrl} target="_blank" rel="noopener noreferrer" style={styles.link}>
                    View Product
                  </a>
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  {getRetailerLogoForProduct(product.retailerName)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default PriceDroppedTilesComponent;
